function Experience() {
  const experiences = [
    {
      company: "Samsung SDS (via Ascendion)",
      role: "Platform Support Engineer L2/L3",
      duration: "Apr 2021 - Mar 2026",
      points: [
        "Production monitoring using ELK Stack and OpenSearch with KQL queries",
        "Reduced MTTR by 25% through structured log-based observability",
        "Supported Jenkins CI/CD pipeline, deployment time reduced to 15 minutes",
        "Managed Redis cache in production including TTL, session management and pub/sub",
        "AWS infrastructure support on EC2 and auto-scaling, contributed to 15% cost reduction",
      ]
    },
    {
      company: "GaadiyaHub (Personal Project)",
      role: "DevOps / SRE",
      duration: "Jan 2019 - Present",
      points: [
        "Built and operate full production platform on AWS with EC2, VPC, ALB, CloudFront, Route53",
        "K3s Kubernetes cluster managing 10 microservices with Helm and Traefik ingress",
        "GitHub Actions CI/CD with self-hosted runner solving VPC firewall constraints",
        "Prometheus and Grafana monitoring stack deployed via Helm",
        "Terraform for AWS infrastructure as code with IAM Identity Center SSO",
      ]
    }
  ];

  return (
    <div className="bg-navy-light py-20 px-8" id="experience">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-light mb-2">
          <span className="text-green font-mono text-xl">03. </span>
          Experience
        </h2>
        <div className="w-64 h-px bg-navy-lighter mb-10"></div>
        <div className="flex flex-col gap-8">
          {experiences.map((exp) => (
            <div key={exp.company} className="bg-navy p-8 rounded border border-navy-lighter hover:border-green transition-all">
              <div className="flex justify-between items-start mb-2">
                <h3 className="text-slate-light font-bold text-xl">{exp.role}</h3>
                <span className="text-green font-mono text-sm">{exp.duration}</span>
              </div>
              <h4 className="text-green mb-6">{exp.company}</h4>
              <ul className="flex flex-col gap-2">
                {exp.points.map((point, index) => (
                  <li key={index} className="text-slate flex gap-2">
                    <span className="text-green mt-1">▹</span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Experience;